exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.user-info-label[data-v-3342773a] {\n  font-weight: 600;\n}\n.bg-primary[data-v-3342773a] {\n  background-color: #822023 !important;\n}\n.text-dark[data-v-3342773a] {\n  font-weight: 600;\n  font-size: 12pt;\n  color: #000 !important;\n}\n.user-revoked-card[data-v-3342773a] {\n  background-color: rgba(220, 53, 69, 0.1) !important;\n}\n.contents-highlight[data-v-3342773a] {\n  font-weight: 600;\n  font-size: 11pt;\n  cursor: pointer;\n}\n.contents-highlight[data-v-3342773a]:hover {\n    color: #822023;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3342773a","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/misc/user-info/UserInfo.vue
// module id = 666
// module chunks = 1